import styles from './App.module.scss';
import {
    createLoginRoutes,
    createChainRoutes,
    createClinicRoutes,
    createDistributorRoutes,
    createAdminRoutes
} from './routes';
import {HashRouter as Router, useHistory as history, useLocation} from "react-router-dom";
import ClinicMenu from "./pages/Clinic/Menu/Menu";
import React, {useEffect} from "react";
import {getPasswordStrength, getUser, getUserClinic, loginWithToken} from './store/auth-slice';
import BottomBar from "./components/miscellaneous/BottomBar/BottomBar";
import SideMenu from "./components/miscellaneous/SideMenu/SideMenu";
import {useDispatch, useSelector} from "react-redux";
import Alerts from "./components/miscellaneous/Alerts/Alerts";
import ReactGA from 'react-ga';
import ChainMenu from "./pages/Chain/Menu/Menu";
import DistributorMenu from "./pages/Distributor/Menu/Menu";
import Cookies from 'universal-cookie';
import TermsAndConditions from "./pages/Auth/TermsAndConditions/TermsAndConditions";
import {setAppLoading, setUnderConstruction} from "./store/app-slice";
import LoadingPage from "./pages/General/LoadingPage/LoadingPage";
import sentry from "./helpers/sentry";
import * as Sentry from "@sentry/react";
import AdminMenu from "./pages/Admin/Menu/Menu";
import PageHeader from "./components/miscellaneous/PageHeader/PageHeader";
import GettingStarted from "./components/GettingStarted/GettingStarted";
import WhatsNew from "./components/WhatsNew/WhatsNew";
import Tour from 'components/Tour/Tour';
import Modal from "./components/miscellaneous/Modal/Modal";
import PasswordChange from "./components/PasswordChange/PasswordChange";
import api from "./helpers/api";
import UnderConstruction from "./pages/General/UnderConstruction/UnderConstruction";
import UsePermission from './helpers/permissions/UsePermission.jsx';

const cookies = new Cookies();
const loginRoutes = createLoginRoutes();
const clinicRoutes = createClinicRoutes();
const chainRoutes = createChainRoutes();
const distributorRoutes = createDistributorRoutes();
const adminRoutes = createAdminRoutes();

let pageName = window.location.href.split('#') && window.location.href.split('#')[1] ? window.location.href.split('#')[1] : '[unknown]'

ReactGA.initialize('UA-173941460-1');
ReactGA.pageview(pageName);


function App() {
    useEffect(async () => {
        await init();
        sentry.init();
    }, []);

    const dispatch = useDispatch();
    const access_token = useSelector(state => state.auth.access_token)
    const password_strength = useSelector(state => state.auth.password_strength)
    const user = useSelector(state => state.auth.user)
    const appLoading = useSelector(state => state.app.loading)
    const underConstruction = useSelector(state => state.app.underConstruction)
    const appShowWhatsNew = useSelector(state => state.app.show_whats_new)
    const pageHeader = useSelector(state => state.app.pageHeader)

    async function init() {
        dispatch(setAppLoading(true));

        try {
            let isApiAlive = await api.get('api-status');
            if (!isApiAlive || !isApiAlive.success) {
                underConstructionHandler()
            }
        } catch (e) {
            console.error('Service is down.');
            underConstructionHandler()
        }

        let windowUrl = window.location.href;

        // console.log('windowUrl', windowUrl);
        if (windowUrl.includes('access_token')) {
            let token = windowUrl.split('access_token=')[1];
            // console.log('token:', token)
            if (token) {
                cookies.set('access_token', token, {path: '/'});
                localStorage.setItem('access_token', token);
            }
        }

        let token = cookies.get('access_token');
        if (token && token !== 'undefined') {
            let res = await dispatch(loginWithToken(token));
            if (res && res.success) {
                let user = await dispatch(getUser());
                if (user.role === 2 || user.role === 3) {
                    let clinicRes = await dispatch(getUserClinic());
                }
            }
        } else {
            if (process.env.REACT_APP_ENV && process.env.REACT_APP_ENV  === 'local') {
                console.log('[!][REDIRECTION BLOCKED][1] env is local, user should be redirected to V2');
            } else {
                // console.log('NO TOKEN: redirect to v2', `${process.env.REACT_APP_FRONT_V2_URL}?logout=true`);
                window.location = `${process.env.REACT_APP_FRONT_V2_URL}?logout=true`;
            }
        }

        dispatch(setAppLoading(false));
    }

    function underConstructionHandler() {
        dispatch(setUnderConstruction(true));
        dispatch(setAppLoading(false));
    }

    return (
        <div className={styles.appContainer}>
            <Alerts/>
            <Router history={history}>
                {underConstruction ?
                    <UnderConstruction/>
                    :
                    <>
                        {appLoading ?
                            <LoadingPage/>
                            :
                            <>
                                {access_token && user ?
                                    <UsePermission>
                                        {user.terms ?
                                            <>
                                                <Modal content={<PasswordChange required/>}
                                                       visible={password_strength === 0 && user.role !== 5}
                                                       showCloseButton={false}
                                                />

                                                <Tour/>
                                                <GettingStarted userRole={user.role} userId={user.id}/>
                                                <WhatsNew userRole={user.role} userId={user.id}
                                                          show={appShowWhatsNew === true ? true : false}/>

                                                {user.role === 2 ?
                                                    <SideMenu>
                                                        <ClinicMenu/>
                                                        <div
                                                            className={`${styles['pages-container']} ${(pageHeader ? null : styles['pages-container-border-radius'])}`}>
                                                            <div className={styles.pageContent}>
                                                                {clinicRoutes}
                                                            </div>
                                                        </div>
                                                        <BottomBar/>
                                                    </SideMenu>
                                                    :
                                                    null
                                                }
                                                {user.role === 3 ?
                                                    <SideMenu>
                                                        <ChainMenu/>
                                                        <div
                                                            className={`${styles['pages-container']} ${(pageHeader ? null : styles['pages-container-border-radius'])}`}>
                                                            <div className={styles.pageContent}>
                                                                {chainRoutes}
                                                            </div>
                                                        </div>
                                                        <BottomBar/>
                                                    </SideMenu>
                                                    :
                                                    null
                                                }
                                                {user.role === 4 ?
                                                    <SideMenu>
                                                        <DistributorMenu/>
                                                        <div
                                                            className={`${styles['pages-container']} ${(pageHeader ? null : styles['pages-container-border-radius'])}`}>
                                                            <div className={styles.pageContent}>
                                                                {distributorRoutes}
                                                            </div>
                                                        </div>
                                                        <BottomBar/>
                                                    </SideMenu>
                                                    :
                                                    null
                                                }
                                                {user.role === 5 ?
                                                    <SideMenu>
                                                        <AdminMenu/>
                                                        <div
                                                            className={`${styles['pages-container']} ${(pageHeader ? null : styles['pages-container-border-radius'])}`}>
                                                            <div className={styles.pageContent}>
                                                                {adminRoutes}
                                                            </div>
                                                        </div>
                                                        <BottomBar/>
                                                    </SideMenu>
                                                    :
                                                    null
                                                }
                                            </>
                                            :
                                            <div><TermsAndConditions/></div>
                                        }
                                    </UsePermission>
                                    :
                                    <>
                                        {loginRoutes}
                                    </>
                                }
                            </>
                        }
                    </>
                }


            </Router>
        </div>
    );
}

export default App;
